import { useMemo } from 'react'
import { RELATIONSHIPS } from 'Data/constants.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return RELATIONSHIPS
  }, [data])
}
